import React, { createContext, useContext, useState } from 'react';
import useMobile from 'hooks/use_mobile';

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const isMobile = useMobile();
  const [sidebarVisible, setSidebarVisible] = useState(!isMobile);

  return (
    <MenuContext.Provider value={{ sidebarVisible, setSidebarVisible }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);
